import { DepotGroup, DepotIndex, Loc } from "./types";

export function nat(a: string, b: string) {
  const ra = /^([A-Za-z]+)?0*(\d+)$/.exec(a);
  const rb = /^([A-Za-z]+)?0*(\d+)$/.exec(b);
  if (ra && rb && (ra[1] || "").toUpperCase() === (rb[1] || "").toUpperCase()) {
    const na = parseInt(ra[2] || "0", 10);
    const nb = parseInt(rb[2] || "0", 10);
    return na - nb;
  }
  return a?.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
}

export function groupByCladire(locations: Loc[]): DepotGroup[] {
  const order: string[] = [];
  const buckets: Record<string, Loc[]> = {};
  for (let i = 0; i < locations.length; i++) {
    const loc = locations[i];
    if (!buckets[loc.cladire]) {
      buckets[loc.cladire] = [];
      order.push(loc.cladire);
    }
    buckets[loc.cladire].push(loc);
  }
  return order.map((cladire) => ({ cladire, data: buckets[cladire] }));
}

export function buildDepotIndex(locs: Loc[]): DepotIndex {
  const byRand: DepotIndex = new Map();
  for (let i = 0; i < locs.length; i++) {
    const loc = locs[i];

    if (!byRand.has(loc.rand)) byRand.set(loc.rand, new Map());
    const byCol = byRand.get(loc.rand)!;

    if (!byCol.has(loc.coloana)) byCol.set(loc.coloana, new Map());
    const byPol = byCol.get(loc.coloana)!;

    if (!byPol.has(loc.polita)) byPol.set(loc.polita, []);
    byPol.get(loc.polita)!.push(loc);
  }
  return byRand;
}

export function avgNivel(
  cells: Array<{ nivelUmplere?: 0 | 25 | 50 | 75 | 100 }>,
) {
  if (!cells.length) return 0;
  let s = 0;
  for (const c of cells) s += c.nivelUmplere ?? 0;
  return Math.round(s / cells.length);
}

export function badgeClassFor(avg: number): string {
  if (avg >= 88) return "wm-k-badge--100";
  if (avg >= 63) return "wm-k-badge--75";
  if (avg >= 38) return "wm-k-badge--50";
  if (avg >= 13) return "wm-k-badge--25";
  return "wm-k-badge--0";
}

export function fillColor(v: number) {
  if (v === 0) return "transparent";
  else if (v > 0 && v < 25) return "#fb923c";
  else if (v >= 25 && v < 50) return "#fb923c";
  else if (v >= 50 && v < 75) return "#facc15";
  else if (v >= 75 && v <= 100) return "#86efac";
}

export type FillPct = 0 | 25 | 50 | 75 | 100;

export const bucketize = (v: number): FillPct => {
  if (!isFinite(v) || v <= 0) return 0;
  if (v < 25) return 25;
  if (v < 50) return 50;
  if (v < 75) return 75;
  return 100;
};
